import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formatter from "../../../../../../../../utils/formatter";
import replaceNonDigit from "../../../../../../../../utils/replaceNonDigit";
import { allocationPreference, updateRecordedVal } from "../../../../actions";
import ExchangeUnitInput from './styles';
let isClear = false;

function InputNum(props) {
  const {
    setFormField,
    setTotal,
    setRecordedVal,
    formField,
    fieldInfoObj,
    poolFieldName,
    fieldRecord,
    recordedVal,
    currentTotal,
    allocationPreference,
    selectChange
  } = props;

  const { fieldSuffix } = fieldInfoObj;

  const [val, setVal] = useState('');

  useEffect(() => {
    setVal(
      formField
      && formatter({
        value: formField[fieldSuffix],
        fieldSuffix,
      }),
    );
    isClear = false;
  }, ([formField && formField[fieldSuffix] || (isClear === true) ]));

  const handleFocus = function handleFocus(e) {
    const formattedVal = +replaceNonDigit(e.target.value);
    setVal(formattedVal === 0 ? '' : formattedVal );
    setRecordedVal(formattedVal);
  };

  const handleBlur = function handleBlur(e) {
    const value = +replaceNonDigit(e.target.value);
    const newTotal = (parseFloat(currentTotal) - parseFloat(recordedVal) + value);
    if (parseInt(newTotal) > 100)
    {
      isClear = true;
      (recordedVal !== value) && setTotal({ value: value - recordedVal });
             setFormField(value);
    } else
    {
      setFormField(value);
      (allocationPreference === "weightedPercentage") && selectChange('customPercentage');
      (recordedVal !== value) && setTotal({ value: value - recordedVal });
    }
    setVal(formatter({
      value,
      fieldSuffix,
      event: "",
      record: fieldRecord,
    }));
  };

  const handleInputChange = function (e) {
    let regex = /^[0-9]{0,3}$/;
    if(regex.test(e.target.value.replace('%','')) && e.target.value.replace('%','').length <=3){
    const { value } = e.target;
    setVal(value);
  }
  };

  return (
    <ExchangeUnitInput
      data-test="wrapper"
      name={poolFieldName}
      value={val}
      aria-label="percentage"
      onChange={e => handleInputChange(e)}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  );
}

InputNum.propTypes = {
  setFormField: PropTypes.func.isRequired,
  setRecordedVal: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  return {
    formField: state.getIn([
      'makeAContribution',
      'contributionAllocation',
      'form',
      `${ownProps.investmentOption+"Form"}`,
      `${ownProps.fieldInfoObj.poolName}`,
    ]),
    exchangeType: state.getIn([
      'makeAContribution',
      'contributionAllocation',
      'allocationPreference'
    ]),
    activeExchangeUnit: 'Percentage',
    recordedVal: state.getIn([
      'makeAContribution',
      'contributionAllocation',
      'recordedVal',
    ]),
    currentTotal: state.getIn(['makeAContribution','contributionAllocation', 'total']),
    allocationPreference: state.getIn(['makeAContribution', 'contributionAllocation',"allocationPreference"]),
    dummyData: state.getIn(['makeAContribution', 'contributionAllocation',"dummyUpdate"]),
  };
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  let investmentOption = ownProps.investmentOption+"Form";
  return {
  setFormField: val => dispatch(ownProps.updateFormFields({
    ...ownProps.fieldInfoObj,
    val,
    investmentOption
  })),
   setTotal: value => dispatch(ownProps.updateTotal(value)),
  setRecordedVal: value => dispatch(updateRecordedVal(value)),
  selectChange: (value) => dispatch(allocationPreference(value)),
}};

export default connect(mapStateToProps, mapDispatchToProps)(InputNum);
